<div class="groupList">
  @for (group of assetDataGroups; track group) {
    <span>
      <p-badge pill="true" [ngStyle]="{'background-color':group.color }"
               pTooltip="{{'sys.group' | translate}}: {{group.label}}" tooltipPosition="top"></p-badge>
    </span>
  }
</div>
